import Vue from 'vue'
import App from './App.vue'
import { i18n } from './i18n'
import router from './router'
import store from './store'
//import VueSocketIO from 'vue-socket.io'
import { Trans } from './plugins/Translation'

import './sass/main.scss'

import defaultState from "./store/defaultState";

import { CalendarPlugin } from '@syncfusion/ej2-vue-calendars';
import { TimePickerPlugin } from '@syncfusion/ej2-vue-calendars';

Vue.use(TimePickerPlugin);
Vue.use(CalendarPlugin);

// Vuetify
// import vuetify from './plugins/vuetify'

//mixins
import './mixins'

// Mulilanguages i18n
Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)


console.log('process.env.VUE_APP_BASE_API_URL', process.env.VUE_APP_BASE_API_URL)

// VueCountdown
// import VueCountdown from '@chenfengyuan/vue-countdown';
// Vue.component(VueCountdown.name, VueCountdown);

// VModal
// import VModal from 'vue-js-modal'
// Vue.use(VModal)

// PerfectScrollbar
// import PerfectScrollbar from 'vue2-perfect-scrollbar'
// Vue.use(PerfectScrollbar)

// Vue.use(new VueSocketIO({
//   debug: false,
//   connection: 'http://15.184.56.140:3000',
//   vuex: {
//     store,
//     actionPrefix: 'SOCKET_',
//     mutationPrefix: 'SOCKET_'
//   },
//   //options: { path: "/my-app/" } //Optional options
// }))


Vue.config.productionTip = false

// GoogleAnalytics
// import VueAnalytics from 'vue-analytics'
// Vue.use(VueAnalytics, {
//   id: 'UA-1111111111-1',
//   router
// })

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

//clear state by key
if (store.state.stateKey < defaultState().stateKey) {
  Object.assign(store.state, defaultState());
  console.log('state cleared by new key - stateKey');
}

String.prototype.splice = function(idx, rem, str) {
  return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
};
